<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ FullName }}</p>
      <!-- <small>Available</small> -->
    </div>

    <vs-dropdown :key="dropdownKey" ref="profilDropdown" vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="Avatar" key="onlineImg" :src="Avatar" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
        <div v-else class="name-avatar">{{ FullNameLetter }}</div>
      </div>


      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            v-if="user_type === 'company_admin'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="Profile()">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>
          <!-- <li
            v-if="user_type === 'user'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile')">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>-->
          <li><!--{{localStorage.getItem('user-type')}}--></li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="TopUp()">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Top-up</span>
          </li>
          <li
            v-if="url !== 'editor' && url !== 'admin'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/setting')">
            <feather-icon icon="ListIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Setting</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['url'],
    data() {
      const user_type = localStorage.getItem('user-type')

      return {
        user_type:'',
        dropdownKey: 1
      }
    },
    created() {
      // this.$vs.notification = []
      this.user_type = localStorage.getItem('user-type')
      // console.log('user_type************',this.user_type)
    },
    computed: {
      UserInfo () {
        return this.$store.getters['user/GetUserInfo']
      },
      FullName () {
        if(this.$store.getters['user/GetUserType'] == 'admin' ){
          return 'Admin'
        }
        return this.$store.getters['user/GetFullName']
      },
      Avatar () {
        const logo_uuid = this.$store.getters['user/GetAvatar']
        // console.log(logo_uuid,"logo_uuid")

        if (!logo_uuid) {
          return null
        }

        return `http://88.198.219.62/api_smsc/v1/file/${logo_uuid}`
      },
      FullNameLetter () {
        const { first_name, last_name } = this.$store.getters['user/GetUserInfo']

        if (!first_name || !last_name) {
          return ''
        }

        return `${first_name[0]}${last_name[0]}`
      },
    },
    watch: {
      '$route.name' (val) {
        if(val === 'page-topup' || val === 'page-settings' || val === 'Company-Admin-Profile'){
          this.dropdownKey++
          console.log( this.dropdownKey++," this.dropdownKey++")
        }
      }
    },
    methods: {
      logout () {
        this.$store.dispatch('auth/Logout')
          .then(res => {

          })
      },
      Profile(){
       return  '/company-admin/profile' === this.$route.path  ? this.$router.go() :this.$router.push('/company-admin/profile')
      },
      TopUp(){
        return  '/pages/topup' === this.$route.path  ? this.$router.go() :this.$router.push('/pages/topup')

      }
    }
  }
</script>

<style lang="scss" scoped>
  .the-navbar__user-meta {
    .con-img {

      img {
        padding: 2px;
      }
      .name-avatar {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 50%;
        font-weight: 600;
        background-color: #7367f0;
        color: #fff;
      }
    }
  }
</style>
